import React from 'react';
import notificationService from './notificationService';

const removeNotification = (callback) => {
  notificationService.removeAlert();
  callback();
}
export default ({title, message, success, onSuccess, cancel, onCancel}) => {
  let titleContainer;
  let cancelButton;
  if(title){
    titleContainer = (
      <div className="alert-title">
        {title}
      </div>
    );
  }
  if(onCancel) {
    cancelButton = (<button type="button" className="btn btn-outline-secondary" onClick={() => removeNotification(onCancel)}>{cancel || "Cancel"}</button>);
  }
  return (
    <div className="cm-alert d-flex align-items-center justify-content-center">
      <div className="card">
        <div className="card-header">
          <h3 className="card-title-lg">
            {titleContainer}
          </h3>
        </div>
        <div className="card-body">
          {message}
        </div>
        <div className="card-footer">
          {cancelButton}
          <button type="button" className="btn btn-secondary control-spacer-left" onClick={() => removeNotification(onSuccess)}>{success || "OK"}</button>
        </div>
      </div>
    </div>
  )
}
